export default "__VITE_ASSET__bd8d3764__"